/** The platform's typed API clients (route types from `@daka/api/rpc`). A module builds its own from its routes. */
import type { I18nRoutes, PlatformRoutes, SsoRoutes } from '@daka/api/rpc';

import { apiClient } from '@/lib/http';

export const platform = apiClient<PlatformRoutes>('/api/platform');
export const i18n = apiClient<I18nRoutes>('/api/i18n');
export const sso = apiClient<SsoRoutes>('/api/sso');
